export default __webpack_public_path__ + "static/media/Logo.0c1c7f91.png";